export default __webpack_public_path__ + "static/layout_cloud_topRight-995f90a3f5e39cc62880e1e8b3928981.png";